// Round to 2 decimal places (the normal case). If that rounds a genuinely
// non-zero value away to 0.00 - e.g. a small ingredient/commitment quantity
// like 0.001 - extend to up to 4 decimals instead, so it stays visibly
// non-zero rather than silently displaying as 0. Safe for display and Excel
// cell values.
export const n2 = (val) => {
  const num = parseFloat(val);
  if (isNaN(num)) return 0;
  if (num === 0) return 0;

  const rounded2 = Math.round(num * 100) / 100;
  if (rounded2 !== 0) return rounded2;

  // rounded2 collapsed to 0 but the original value didn't - show up to 4
  // decimals (still 0 only for values smaller than 0.00005).
  return Math.round(num * 10000) / 10000;
};

// Normalise unit strings to consistent uppercase (e.g. "kg" → "KG").
export const normalizeUnit = (u) => (u ? u.trim().toUpperCase() : '');
